/**
 * Active/inactive labels for organization master-data rows.
 * Backend child entities expose isActive; organization uses statusId.
 */
export function getMasterDataStatusLabel(
  isActive: boolean | null | undefined,
  statusCode?: string | null,
): string {
  if (statusCode && statusCode.trim()) {
    const code = statusCode.trim().toUpperCase();
    if (code === 'ACTIVE') return 'Active';
    if (code === 'INACTIVE') return 'Inactive';
    if (code === 'DRAFT') return 'Draft';
    if (code === 'ARCHIVED') return 'Archived';
    return statusCode.trim();
  }

  if (isActive === true) return 'Active';
  if (isActive === false) return 'Inactive';
  return 'Status unavailable';
}
